module.exports = __webpack_public_path__ + "img/7.d301f37b.jpg";